/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { RouterModule, Routes } from '@angular/router';

import { CanDeactivateViaEditGuardService } from './../core/services/can-deactivate-via-edit-guard.service';
import { NgModule } from '@angular/core';
import { QueryViewComponent } from './query-view.component';
import { QueryViewDataComponent } from './data/query-view-data.component';
import { QueryViewResolver } from './shared/query-view.resolver';

const queryViewRoutes: Routes = [
    {
        path: 'query-view',
        component: QueryViewComponent,
        data: { tab: 'Query-View' },
        resolve: {
            tabData: QueryViewResolver
        },
        canDeactivate: [CanDeactivateViaEditGuardService],
        children: [
            {
                path: 'data',
                component: QueryViewDataComponent,
                data: { tab: 'Query-View' },
                resolve: {
                    tabData: QueryViewResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'data/:tabid',
                component: QueryViewDataComponent,
                data: { tab: 'Query-View' },
                resolve: {
                    tabData: QueryViewResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            }]
    }
];


/**
 * @export
 * @class LocoRoutingModule
 */
@NgModule({
    imports: [
        RouterModule.forChild(queryViewRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class QueryViewRoutingModule {

}
